import { render, staticRenderFns } from "./Trainer.vue?vue&type=template&id=3cb9c890&scoped=true&lang=pug&"
import script from "./Trainer.vue?vue&type=script&lang=js&"
export * from "./Trainer.vue?vue&type=script&lang=js&"
import style0 from "./Trainer.vue?vue&type=style&index=0&id=3cb9c890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb9c890",
  null
  
)

export default component.exports